import { MOET_CONSTANTS } from 'moet-core';

import kyc from './kyc';

import { AuStakeholderBlock } from '@/flow/blocks/kyc/AuStakeholder.block';
import { UsStakeholderBlock } from '@/flow/blocks/kyc/UsStakeholder.block';
import { SfsaStakeholderBlock } from '@/flow/blocks/kyc/SfsaStakeholder.block';
import { FcaStakeholderBlock } from '@/flow/blocks/kyc/FcaStakeholder.block';

const { MANAGED_ONBOARDING_TYPES } = MOET_CONSTANTS;

const stakeholderBlockMap = (region, country) => {
  if (region === 'eu' && ['GB', 'IT'].includes(country)) {
    return FcaStakeholderBlock;
  } else {
    return {
      eu: SfsaStakeholderBlock,
      ap: AuStakeholderBlock,
      us: UsStakeholderBlock,
    }[region];
  }
};

export function merchantApplicationFlow(options) {
  const { merchant, widgetType, merchantCountryConfig } = options;
  const region = options.region.toLowerCase();

  const isManagedFlow = MANAGED_ONBOARDING_TYPES.includes(widgetType);
  const StakeholderBlock = stakeholderBlockMap(region, merchant.country);
  const flow = kyc({
    isManagedFlow,
    StakeholderBlock,
    countryConfig: merchantCountryConfig,
    ...options,
  });

  const filterLinks = links => {
    if (!Array.isArray(links)) {
      return links;
    }

    let foundFirst = false;
    const filteredLinks = links.filter(({ condition }) => {
      // if we found the first true, we can remove everything after it
      if (foundFirst || !condition) {
        return false;
      }

      if (condition === true) {
        foundFirst = true;
      }

      return true;
    });

    return filteredLinks.length === 1 && filteredLinks[0].condition === true
      ? filteredLinks[0].path
      : filteredLinks;
  };

  return {
    ...flow,
    steps: flow.steps
      .filter(step => step.exclude !== true)
      .map(({ exclude, ...step }) => ({
        ...step,
        back: filterLinks(step.back),
        next: filterLinks(step.next),
      })),
  };
}
